<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Hiba részletei</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'log_entry', log_entry ],
				fields: [
					{ type: 'row', fields: [
						{ type: 'col', fields: [
							{
								type: 'textarea',
								name: 'stack',
								inline: true,
								attributes: {
									readonly: true,
									style: 'height:500px;'
								}
							}
						]}
					]}
				]
			}) %>
		</div>
		<div class="modal-footer text-end">
			<!--<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>-->
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	/*
	async save () {
		const res = await Anvil.exec('c_order/company_db/action_save', Anvil.page.modal.company_db)

		if (res === true) {

			// Refresh list
			await Anvil.exec('c_order/company_db/action_refresh')

			// Focus on company
			let grid = Anvil.models.components.Grid.find('#company_db_grid')
			grid.select(grid.list.getById(Anvil.page.modal.company_db.id), true)

			// Close modal
			Anvil.page.modal.close()
		}
	}
	*/
})
</script>
